import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function resolveIp(request: Request) {
    const isIPv6 = (ip: string) => {
        return ip.includes(":") && /^[0-9a-fA-F:]+$/.test(ip);
    };

    const cfConnectingIp = request.headers.get("cf-connecting-ip");

    if (cfConnectingIp) {
        // if (isIPv6(cfConnectingIp)) {
        //     const cfPseudoIpv4 = request.headers.get("cf-pseudo-ipv4");
        //     if (cfPseudoIpv4) {
        //         return cfPseudoIpv4;
        //     }
        // }
        return cfConnectingIp;
    }

    const xForwardedFor = request.headers.get("x-forwarded-for");

    if (xForwardedFor) {
        return xForwardedFor.split(",")[0];
    }

    // @ts-ignore
    return request.connection?.remoteAddress || null;
}

export const MAX_AGE = 60 * 60 * 24 * 30; // 30 days

export function jsonToFormData(values: Record<string, any>) {
    const formData = new FormData();
    for (const key in values) {
        const value = values[key];
        if (!value) {
            continue;
        }
        formData.append(key, value);
    }
    return formData;
}

export function caseInsensitiveComparator(valueA: string, valueB: string) {
    if (!valueA) return -1;
    if (!valueB) return 1;
    return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
}

export function isIntersecting(rect1?: DOMRect, rect2?: DOMRect) {
    if (!rect1 || !rect2) {
        return false;
    }
    return !(
        (
            rect1.right < rect2.left || // WebDialer is completely to the left of AI Chat
            rect1.left > rect2.right || // WebDialer is completely to the right of AI Chat
            rect1.bottom < rect2.top || // WebDialer is completely above AI Chat
            rect1.top > rect2.bottom
        ) // WebDialer is completely below AI Chat
    );
}

export function createSearchParams(params: Record<string, any>) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, values]) => {
        if (Array.isArray(values)) {
            values.forEach((value) => {
                if (value === undefined || value === null) return;
                searchParams.append(key, value);
            });
        } else {
            // URLSearchParams stringifies whatever it is given, so an absent filter would go on the
            // wire as the literal "undefined" (e.g. `direction=undefined`). No caller ever wants
            // that; an omitted param is how you say "no filter".
            if (values === undefined || values === null) return;
            searchParams.append(key, values);
        }
    });
    return searchParams;
}

export function isDevOrStaging(host: string): boolean {
    const values: string[] = [
        // "pbxstage.net",
        // 'pbxdev.net',
        "localhost",
        // "pbxlocal",
    ];

    return values.some((v) => host.includes(v));
}
